import * as angular from 'angular';
import * as _ from 'lodash';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import BatchFormulasServiceName, {BatchFormulasService} from "../../services/batches/batchFormulas.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsCommon} from "../../shared/dto/aps.common";
import template from './addBatchFormula.tpl.html';

let requires = [BatchFormulasServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface AddBatchFormulaController {
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];
  add(): void;
  addMaterial(): void;
  removeMaterial(material: apsViewModels.BatchMaterialItem): void;
  cancel(): void;
}

export interface AddBatchFormulaParams {
  plant: Plant;
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];
  allBatchFormulas: apsViewModels.BatchFormulaItem[];
}

export function openAddBatchFormula(data: AddBatchFormulaParams,
                                 $modal: mm.foundation.modal): angular.IPromise<apsViewModels.BatchFormulaItem> {
  return $modal.open({
    template: template,
    controller: 'AddBatchFormulaCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class AddBatchFormulaCtrl implements AddBatchFormulaController {
  instance: apsViewModels.BatchFormulaDetail;
  form: angular.IFormController;
  allBatchFormulas: apsViewModels.BatchFormulaItem[];
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];

  private batchFormulasService: BatchFormulasService;
  private $modalInstance: mm.foundation.modalInstance;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newGuidService: NewGuidService;

  constructor(
    data: AddBatchFormulaParams,
    newGuidService: NewGuidService,
    batchFormulasService: BatchFormulasService,
    $modalInstance: mm.foundation.modalInstance,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.batchFormulasService = batchFormulasService;
    this.$modalInstance = $modalInstance;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.newGuidService = newGuidService;
    this.instance = <apsViewModels.BatchFormulaDetail>{
      plantId: data.plant.id,
      plantName: data.plant.name,
      material: []
    };
    this.allBatchFormulas = data.allBatchFormulas;
    this.commodities = data.commodities;
    this.glassColors = data.glassColors;

    this.newGuidService.getNewGuid('BatchFormula').then(id => this.instance.id = id);
  }

  add(): void {
    if (this.form.$invalid) {
      return;
    }

    let command = <apsCommands.AddBatchFormula>this.instance;

    this.loaderService.loadingPromise(this.batchFormulasService.add(command)
      .then(() => {
        this.instance.colorName = _.find(this.glassColors, {id: this.instance.colorId}).name;
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }
  
  addMaterial(): void {
    let material = <apsViewModels.BatchMaterialItem>{};
    this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchMaterial')
      .then(id => {
        material.id = id;
        this.instance.material.push(material);
      }));
  }

  removeMaterial(material: apsViewModels.BatchMaterialItem): void {
    _.remove(this.instance.material, material);
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.addBatchFormula', requires)
  .controller('AddBatchFormulaCtrl', AddBatchFormulaCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/addBatchFormula.controller.ts